export default "__VITE_ASSET__D0RRoWzM__"